import tag from '@components/utility-components';
import * as styles from './options-controls.module.scss';
export function createAddButton(add) {
    return tag.button({
        classes: ['button', styles.addBtn],
        text: 'Add Option',
        onclick: add,
    });
}
export function createPasteButton(paste) {
    return tag.button({
        classes: ['button', styles.pasteBtn],
        text: 'Paste List',
        onclick: paste,
    });
}
export function createClearButton(clear) {
    return tag.button({
        classes: ['button', styles.clearBtn],
        text: 'Clear List',
        onclick: clear,
    });
}
export function createSaveButton(save) {
    return tag.button({
        classes: ['button', styles.saveBtn],
        text: 'Save List',
        onclick: save,
    });
}
export function createLoadButton(load) {
    return tag.button({
        classes: ['button', styles.loadBtn],
        text: 'Load List',
        onclick: load,
    });
}
export function createStartButton(start) {
    return tag.a({
        href: './picker',
        classes: ['button', styles.startBtn],
        text: 'Start',
        onclick: start,
    });
}
